import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { CoreModule } from '@core/core.module';
import { WifiHealthComponent } from '@app/features/wifi/modules/wifi-health/wifi-health.component';
import { DeviceModule } from '@app/features/device-health/device.module';
import { HealthNavComponent } from '@app/shared/components/health-nav/health-nav.component';

@NgModule({
    imports: [
        CommonModule,
        CoreModule,
        SharedModule,
        DeviceModule,
        HealthNavComponent
    ],
    declarations: [
        WifiHealthComponent
    ],
    providers: [],
    exports: [],
    bootstrap: []
})
export class WifiModule {}